const STORAGE_KEY = 'ss-gt-market-prompt';
const TARGET_COUNTRY = 'GT';

function getPrompt() {
  return document.getElementById('gt-market-prompt');
}

function hasChoice() {
  try {
    return Boolean(window.localStorage.getItem(STORAGE_KEY));
  } catch (error) {
    return false;
  }
}

function saveChoice(value) {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch (error) {
    // Ignore private-mode storage errors.
  }
}

function detectCountryCode(payload) {
  const detected = payload?.detected_values || {};
  const suggestion = payload?.suggestions?.[0];
  const raw =
    detected.country?.handle ||
    detected.shopify_country?.iso_code ||
    detected.country?.iso_code ||
    suggestion?.parts?.find((part) => part.country)?.country?.handle ||
    '';

  return String(raw).toUpperCase();
}

function closePrompt() {
  const dialog = getPrompt();
  if (dialog instanceof HTMLDialogElement && dialog.open) {
    dialog.close();
  }
}

function openPrompt() {
  const dialog = getPrompt();
  if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;
  if (typeof dialog.showModal === 'function') {
    dialog.showModal();
  } else {
    dialog.setAttribute('open', '');
  }
}

function stayHere() {
  saveChoice('stay');
  closePrompt();
}

function goToGuatemala() {
  saveChoice('gt');
  const form = document.getElementById('GtMarketPromptForm');
  if (form instanceof HTMLFormElement) {
    form.submit();
    return;
  }

  const dialog = getPrompt();
  const fallback = dialog?.dataset.gtUrl || '/es-gt';
  window.location.assign(fallback);
}

function isDemo() {
  return new URLSearchParams(window.location.search).has('guatemalademo');
}

async function maybePrompt() {
  const dialog = getPrompt();
  if (!dialog) return;

  if (isDemo()) {
    openPrompt();
    return;
  }

  if (document.documentElement.dataset.market === 'es-gt') return;
  if (hasChoice()) return;

  try {
    const response = await fetch('/browsing_context_suggestions.json', {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return;

    const country = detectCountryCode(await response.json());
    if (country === TARGET_COUNTRY) openPrompt();
  } catch (error) {
    console.error('GT market prompt error:', error);
  }
}

document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-gt-prompt]') : null;
  if (!button) return;

  const action = button.getAttribute('data-gt-prompt');
  if (action === 'stay') stayHere();
  if (action === 'go') goToGuatemala();
});

document.addEventListener('DOMContentLoaded', maybePrompt);
